import React, {useEffect, useRef, useState} from "react";
import {apiURL} from "../../api";
import ButtonBase from "@material-ui/core/ButtonBase";

function PagePlaceholder(props) {
    let {page, placeholder, openSignaturePad, computed, loaded, signerMode, canSign, provideElement} = props;
    let [pelement, setProvideElement] = provideElement;
    let [image, setImage] = useState(null);

    let ref = useRef(null);

    useEffect(() => {
        if (ref) {
            pelement[placeholder.id] = {
                element: ref.current,
                placeholder: placeholder
            };
            setProvideElement({
                ...pelement
            });
        }
    }, [ref, ref ? ref.current : null, loaded]);

    let getImage = () => {
        if (placeholder.image) {
            return apiURL('serve/' + placeholder.image);
        }
        return image;
    };
    let imageEl = getImage() ?
        <img style={{height: computed.height, visibility: loaded ? undefined : 'hidden', width: 'auto'}}
             src={getImage()} alt={""}/> : null;


    if (!signerMode || !canSign) {
        return <div className={'placeholder'}
                    style={computed}><span>{imageEl}</span></div>
    }

    let openSig = () => {
        openSignaturePad(page, {
            computed: computed,
            placeholder: placeholder,
            set: (newState) => {
                placeholder._text = newState.text;
                placeholder._text_color = newState.text_color;
                placeholder._text_font = newState.text_font;
            }
        }, (image) => {
            placeholder._image = image;
            setImage(image);
        }, image);
    };

    placeholder.openSignInput = openSig;

    return <ButtonBase
        onClick={openSig}
        className={'placeholder'}
        style={computed}><span ref={ref}>{imageEl}</span>
    </ButtonBase>;
}


export default PagePlaceholder;